<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small class="bar-icon-btn" aria-label="Controle do mosaico" v-bind="attrs" v-on="on">
        <v-icon small> mdi-tune </v-icon>
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-tune</v-icon>
        <div>
          <span class="sc-modal__title">Controle do mosaico</span>
          <span class="sc-modal__subtitle">Ajuste a visualização em tempo real</span>
        </div>
      </div>

      <!-- Settings -->
      <div class="sc-modal__body controle-body">
        <!-- Theme -->
        <div class="sc-settings-list__row">
          <div class="sc-settings-list__info">
            <v-icon small color="text_secondary" class="mr-2">mdi-palette-swatch</v-icon>
            <span class="sc-settings-list__name">Tema do mosaico</span>
          </div>
          <v-select
            :disabled="configsMosaico.length === 0"
            v-model="selectedConfig"
            solo flat dense
            return-object
            :items="configsMosaico"
            item-value="idConfigMosaico"
            placeholder="Selecionar configuração"
            background-color="surface_tertiary"
            hide-details
            class="controle-select"
          >
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-content>
                  <div class="d-flex align-center justify-space-between" style="width: 100%">
                    <span>{{ item.dscNomeConfig.length > 25 ? `${item.dscNomeConfig.substring(0, 24)}...` : item.dscNomeConfig }}</span>
                    <div class="controle-color-dots">
                      <div class="controle-dot" :style="{ 'background-color': item.dscCorBackground, 'background-image': item.urlImgBackground ? `url(${item.urlImgBackground})` : 'none', 'background-size': 'cover' }"></div>
                      <div class="controle-dot" :style="{ 'background-color': item.dscCorCard }"></div>
                      <div class="controle-dot" :style="{ 'background-color': item.dscCorFonte }"></div>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <div class="d-flex align-center">
                <span class="mr-2">{{ item.dscNomeConfig.length > 20 ? `${item.dscNomeConfig.substring(0, 19)}...` : item.dscNomeConfig }}</span>
                <div class="controle-color-dots">
                  <div class="controle-dot" :style="{ 'background-color': item.dscCorBackground, 'background-image': item.urlImgBackground ? `url(${item.urlImgBackground})` : 'none', 'background-size': 'cover' }"></div>
                  <div class="controle-dot" :style="{ 'background-color': item.dscCorCard }"></div>
                  <div class="controle-dot" :style="{ 'background-color': item.dscCorFonte }"></div>
                </div>
              </div>
            </template>
          </v-select>
        </div>

        <!-- Orientation -->
        <div class="sc-settings-list__row">
          <div class="sc-settings-list__info">
            <v-icon small color="text_secondary" class="mr-2">mdi-view-grid</v-icon>
            <span class="sc-settings-list__name">Tipo de mosaico</span>
          </div>
          <v-select
            v-model="selectedOrientacao"
            :items="orientacaoMosaico"
            return-object
            solo flat dense
            item-value="config"
            item-text="description"
            background-color="surface_tertiary"
            hide-details
            placeholder="Selecionar tipo"
            class="controle-select"
          />
        </div>

        <!-- Font size -->
        <div class="sc-settings-list__row">
          <div class="sc-settings-list__info">
            <v-icon small color="text_secondary" class="mr-2">mdi-format-size</v-icon>
            <span class="sc-settings-list__name">Tamanho da fonte</span>
          </div>
          <v-select
            :items="fontSizes"
            v-model="selectedFontSize"
            item-value="value"
            item-text="text"
            return-object
            solo flat dense
            background-color="surface_tertiary"
            hide-details
            placeholder="Selecionar"
            class="controle-select"
          />
        </div>

        <!-- Screensaver toggle -->
        <div class="sc-settings-list__row">
          <div class="sc-settings-list__info">
            <v-icon small color="text_secondary" class="mr-2">mdi-image-multiple</v-icon>
            <div class="sc-settings-list__text">
              <span class="sc-settings-list__name">Tela de descanso</span>
              <span class="sc-settings-list__desc">Exibir imagens quando não houver conteúdo</span>
            </div>
          </div>
          <v-switch
            v-model="usar_tela_descanso"
            color="primary" hide-details dense
            class="mt-0 pt-0"
          />
        </div>

        <!-- Show UF toggle -->
        <div class="sc-settings-list__row">
          <div class="sc-settings-list__info">
            <v-icon small color="text_secondary" class="mr-2">mdi-map-marker</v-icon>
            <div class="sc-settings-list__text">
              <span class="sc-settings-list__name">Exibir UF do colaborador</span>
              <span class="sc-settings-list__desc">Mostrar a sigla do estado no mosaico</span>
            </div>
          </div>
          <v-switch
            v-model="exibir_uf_colaborador"
            color="primary" hide-details dense
            class="mt-0 pt-0"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          @click.prevent="aplicarConfiguracoes"
          :loading="loadingSave"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Aplicar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ModalControleMosaico",
  props: {
    codProducao: Number,
    idConfigAtiva: Number,
  },
  data() {
    return {
      dialog: false,
      loadingSave: false,
      selectedFontSize: null,
      fontSizes: [
        { text: "Pequeno", value: 1, fontSize: "14px", fontClass: "text-h6" },
        { text: "Normal", value: 2, fontSize: "18px", fontClass: "text-h5" },
        { text: "Grande", value: 3, fontSize: "22px", fontClass: "text-h4" },
        { text: "Muito Grande", value: 4, fontSize: "26px", fontClass: "text-h3" },
      ],
      selectedConfig: null,
      selectedOrientacao: null,
      orientacaoMosaico: [
        { config: "C", description: "Coluna" },
        { config: "G", description: "Galeria" },
      ],
      usar_tela_descanso: false,
      qtd_de_cards_por_linha: 1,
      exibir_uf_colaborador: true,
    };
  },
  beforeMount() {
    if (this.idConfigAtiva) {
      this.selectedConfig = this.configsMosaico.find(
        (config) => config.idConfigMosaico === this.idConfigAtiva
      );
    }
    if (this.$store.state.producoes.selectedProducao) {
      const storedTelaDescanso = localStorage.getItem("@socialcam/usar_tela_descanso");
      this.usar_tela_descanso =
        (storedTelaDescanso && storedTelaDescanso !== "undefined")
          ? JSON.parse(storedTelaDescanso)
          : false;
      this.exibir_uf_colaborador = this.$store.state.producoes.selectedProducao.settings?.mosaico?.exibir_uf ?? true;
      this.selectedFontSize = this.fontSizes.find(
        (size) =>
          size.fontClass ===
          this.$store.state.producoes.selectedProducao.dsc_font_size_texto_mosaico
      ) || null;
    }
  },
  computed: {
    ...mapGetters({
      telas_descanso: "telas_descanso/getTelasDescanso",
      configsMosaico: "mosaico/getConfigsMosaico",
      configSelecionada: "mosaico/getConfigSelecionada",
      orientacaoSelecionada: "mosaico/getOrientacaoSelecionada",
      quantidadeDeCardsPorLinha: "mosaico/getQuantidadeDeCardsPorLinha",
    }),
  },
  watch: {
    configsMosaico(newVal) {
      this.selectedConfig = newVal.find(
        (config) => config.idConfigMosaico === this.idConfigAtiva
      );
    },
    configSelecionada(newVal) {
      if (!this.dialog) {
        this.selectedConfig = newVal;
      }
    },
    orientacaoSelecionada(newVal) {
      this.selectedOrientacao = this.orientacaoMosaico.find(
        (orientacao) => orientacao.config === newVal
      );
    },
    quantidadeDeCardsPorLinha(newVal) {
      this.qtd_de_cards_por_linha = newVal;
    },
  },
  methods: {
    ...mapActions({
      updatePreferenciasMosaico: "mosaico/updatePreferenciasMosaico",
    }),
    close() {
      this.$emit("close");
      this.dialog = false;
    },
    async aplicarConfiguracoes() {
      this.loadingSave = true;
      try {
        await apiClient.patch("/atualizarFlgUsarTelaDescanso", {
          cod_producao: this.codProducao,
          usar_tela_descanso: this.usar_tela_descanso,
        });

        await apiClient.patch("/updateFontSizeTextoMosaico", {
          cod_producao: this.codProducao,
          dsc_font_size_texto_mosaico: this.selectedFontSize?.fontClass || "text-h5",
        });

        await this.updatePreferenciasMosaico({
          codProducao: this.codProducao,
          configSelecionada: this.selectedConfig || null,
          orientacaoSelecionada: this.selectedOrientacao?.config || "G",
          qtd_de_cards_por_linha: this.qtd_de_cards_por_linha,
          exibir_uf: this.exibir_uf_colaborador,
        });

        localStorage.setItem("@socialcam/usar_tela_descanso", this.usar_tela_descanso);
        this.$toast.success("Novas configurações aplicadas.");
        this.close();
      } catch (error) {
        this.$toast.error("Erro ao aplicar configurações.");
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.controle-body {
  gap: 4px;
}

.controle-select {
  max-width: 220px;
  flex-shrink: 0;
}

.controle-color-dots {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.controle-dot {
  height: 18px;
  width: 18px;
  border-radius: 4px;
  border: 1px solid var(--sc-border-hover);
}

::v-deep .v-input--switch { margin: 0; padding: 0; }
</style>
